import { ValidSource } from "@validator/schema";
import { UploadToken, UploadTokenSchema, SubmissionReportData } from "@shared/types";

interface CreateParams {
  studyKey: string;
  filename: string;
  size: number;
  sha256: string;
  source: ValidSource | "unknown";
  validated: boolean;
  truncated: boolean;
  week: number;
  report: SubmissionReportData | null;
}

export async function createUploadToken(params: CreateParams): Promise<UploadToken> {
  const url = new URL("/api/upload-token", import.meta.env.VITE_BACKEND_URL);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(body?.error ?? `Request failed with status ${response.status}`);
  }

  const data = await response.json();

  const result = UploadTokenSchema.safeParse(data);

  if (!result.success) {
    throw new Error("Invalid upload token returned from service");
  }

  return result.data;
}
